export default "__VITE_ASSET__CpFFSBd0__"